/*
  HOW TO USE:
    Wrap section in <background-changer data-background-color='#FFFFFF'> node and
    make sure <body> has "tw-transition-colors".
*/
if (!customElements.get('background-changer')) {
  // NF: the instance that most recently set the colour. Only that instance may
  // clear it again, so two changers overlapping the midpoint during one scroll
  // can't undo each other's work regardless of listener order.
  var currentOwner = null

  customElements.define('background-changer',
    class BackgroundChanger extends HTMLElement {
      scrollListening = false

      constructor() {
        super()

        if (!this.dataset.backgroundColor) return

        // DD: so we get a proper this.clientHeight
        this.classList.add('tw-block')

        // bindings
        this.whenInViewport = this.whenInViewport.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
        this.intersectionRatio = this.dataset.intersectionRatio || 0.5

        // listeners
        this.observer = new IntersectionObserver(this.whenInViewport, { threshold: [0, 0.01] });
        this.observer.observe(this)

        // on load
        this.handleScroll()
      }

      whenInViewport(entries) {
        if (entries[0].intersectionRatio === 0) {
          this.releaseColor()
          this.stopScrollListener()
        }
        else
          this.startScrollListener()
      }

      startScrollListener() {
        if (this.scrollListening) return
        
        this.scrollListening = true
        document.addEventListener('scroll', this.handleScroll)
      }
    
      stopScrollListener() {
        this.scrollListening = false
        document.removeEventListener('scroll', this.handleScroll)
      }

      handleScroll() {
        // DD: scroll position + half the viewport height
        var wh = window.scrollY + window.innerHeight / 2
        // DD: scroll position + element top relative to viewport (can be negative)
        var et = window.scrollY + this.getBoundingClientRect().top

        if(et <= wh && et + this.clientHeight > wh) {
          document.documentElement.style.setProperty('--background-changer-color', this.dataset.backgroundColor)
          currentOwner = this
        }
        else
          this.releaseColor()
      }

      // NF: drop back to the page's own background. Removing the property (rather
      // than setting a colour) restores exactly how the page looks on first load,
      // before any changer has run.
      releaseColor() {
        if (currentOwner !== this) return

        document.documentElement.style.removeProperty('--background-changer-color')
        currentOwner = null
      }
    }
  )
}